/**
 * @generated SignedSource<<097a86a75784bd08002047b3aaaf6c8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AllMessagesScreen_Query$variables = {
  first: number;
};
export type AllMessagesScreen_Query$data = {
  readonly Viewer: {
    readonly Messaging: {
      readonly MessageInformation: {
        readonly id: string;
        readonly numUnseenMessages: number;
      };
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"AllMessagesScreen_MessagesPaginationFragment">;
};
export type AllMessagesScreen_Query = {
  response: AllMessagesScreen_Query$data;
  variables: AllMessagesScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "MessageInformation",
  "kind": "LinkedField",
  "name": "MessageInformation",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numUnseenMessages",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllMessagesScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessagingViewerSchema",
            "kind": "LinkedField",
            "name": "Messaging",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "AllMessagesScreen_MessagesPaginationFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllMessagesScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessagingViewerSchema",
            "kind": "LinkedField",
            "name": "Messaging",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "MessagesConnection",
                "kind": "LinkedField",
                "name": "Messages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessagesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Message",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageDefinition",
                            "kind": "LinkedField",
                            "name": "messageDefinition",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageDefinitionPagesConnection",
                                "kind": "LinkedField",
                                "name": "pages",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MessageDefinitionPagesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MessageDefinitionPage",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "image",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "url",
                                                "storageKey": null
                                              },
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v1/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "internalTitle",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "MessageDefinition",
                                            "kind": "LinkedField",
                                            "name": "messageDefinition",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "buttonOpt",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isMessageDefinitionButtonInterface"
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "type",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v5/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "link",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "MessageDefinitionLinkButton",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v5/*: any*/)
                                                    ],
                                                    "type": "MessageDefinitionConfirmButton",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasSeen",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "AllmessagesScreen_Messages",
                "kind": "LinkedHandle",
                "name": "Messages"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d6ee5582e9089ea79352dd187e316cd0",
    "id": null,
    "metadata": {},
    "name": "AllMessagesScreen_Query",
    "operationKind": "query",
    "text": "query AllMessagesScreen_Query(\n  $first: Int!\n) {\n  Viewer {\n    Messaging {\n      MessageInformation {\n        id\n        numUnseenMessages\n      }\n    }\n  }\n  ...AllMessagesScreen_MessagesPaginationFragment_3ASum4\n}\n\nfragment AllMessagesScreen_MessagesPaginationFragment_3ASum4 on Query {\n  Viewer {\n    Messaging {\n      Messages(first: $first) {\n        edges {\n          node {\n            id\n            messageDefinition {\n              pages {\n                edges {\n                  node {\n                    image {\n                      url\n                      id\n                    }\n                    id\n                  }\n                }\n              }\n              id\n            }\n            ...MessagePreview_MessageFragment\n            ...MessageModal_MessageFragment\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n\nfragment ConfirmButton_MessageDefinitionConfirmButtonFragment on MessageDefinitionConfirmButton {\n  title\n}\n\nfragment LinkButton_MessageDefinitionLinkButtonFragment on MessageDefinitionLinkButton {\n  title\n  link\n}\n\nfragment MessageDefinitionButton_MessageDefinitionButtonFragment on MessageDefinitionButtonInterface {\n  __isMessageDefinitionButtonInterface: __typename\n  type\n  ... on MessageDefinitionLinkButton {\n    ...LinkButton_MessageDefinitionLinkButtonFragment\n  }\n  ... on MessageDefinitionConfirmButton {\n    ...ConfirmButton_MessageDefinitionConfirmButtonFragment\n  }\n}\n\nfragment MessageModal_MessageFragment on Message {\n  id\n  messageDefinition {\n    pages {\n      edges {\n        node {\n          id\n          image {\n            url\n            id\n          }\n          ...MessagePage_MessageDefinitionPageFragment\n        }\n      }\n    }\n    id\n  }\n  hasSeen\n}\n\nfragment MessagePage_MessageDefinitionPageFragment on MessageDefinitionPage {\n  image {\n    url\n    id\n  }\n  internalTitle\n  messageDefinition {\n    buttonOpt {\n      __typename\n      ...MessageDefinitionButton_MessageDefinitionButtonFragment\n    }\n    id\n  }\n}\n\nfragment MessagePreview_MessageFragment on Message {\n  messageDefinition {\n    pages {\n      edges {\n        node {\n          internalTitle\n          image {\n            url\n            id\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n  hasSeen\n}\n"
  }
};
})();

(node as any).hash = "492d3152713bbb92e55faa3587782189";

export default node;
